module.exports = {"TXTWCL_Account_details":{"id":"TXTWCL_Account_details","defaultMessage":"Informations de compte"}}